/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation publishHookActionMutation($id: ID!) {
        result: publishEntity(type: "system_hook_action", id: $id) {
            id
        }
    }
`;
